import { Box, Card, Group, Text } from '@mantine/core';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedPrice } from '../../../../../../components/common/data-display/price';
import Counter from '../../../../../../components/common/input/counter';
import cartSlice from '../../../../../../reducers/cart';
import { AppDispatch, RootState } from '../../../../../../stores';

interface MenuOrderItemProps {
  orderItemId: string;
}

const MenuOrderItem = ({ orderItemId }: MenuOrderItemProps) => {
  const dispatch: AppDispatch = useDispatch();

  // const { orderItemToppings, title, temporaryOrderId, count, minCount, maxCount } = orderItem;

  const { items } = useSelector((state: RootState) => state.cart);
  const relevantOrderItems = items.filter((orderItem) => orderItem.id === orderItemId);

  // const totalToppingsPrice =
  //   orderItemToppings?.reduce(
  //     (previousValue, item) => previousValue + item.price,
  //     orderItem.price - orderItem.discount
  //   ) || 0;

  // const toppingText = orderItemToppings?.map((topping) => topping.title).join(', ') || 'بدون افزودنی';

  const handleCounterChange = (newCounter: number, tempId: string) => {
    dispatch(
      cartSlice.actions.updateOrderItem({
        temporaryOrderId: tempId,
        count: newCounter,
      })
    );
  };

  return relevantOrderItems.map((orderItem) => (
    // <MenuOrderItem key={orderItem.temporaryOrderId} orderItem={orderItem} />
    <Card key={orderItem?.id} sx={(theme) => ({ borderColor: theme.colors.brand[8] })} withBorder>
      <Box>
        <Text size="xs" weight="bold">
          {orderItem?.title}
        </Text>
        <Text size="xs" color="brand.2">
          {orderItem?.orderItemToppings?.map((topping) => topping.title).join(', ') || 'بدون افزودنی'}
        </Text>
      </Box>

      <Group position="apart">
        <FormattedPrice
          price={
            orderItem?.orderItemToppings?.reduce(
              (previousValue, item) => previousValue + item.price,
              orderItem.price - orderItem.discount
            ) || 0
          }
        />
        <Counter
          value={orderItem?.count}
          onChange={handleCounterChange}
          min={orderItem?.minCount}
          max={orderItem?.maxCount}
          tempId={orderItem?.temporaryOrderId}
        />
      </Group>
    </Card>
  ));
};

export default memo(MenuOrderItem);
